export default __webpack_public_path__ + "static/media/icon-data-error.f39cfdad.svg";